













































import Vue from "vue";

export default Vue.extend({
    props: {
        item: {
            type: Object,
            required: true
        },
    },
    data: function() {
        return {
            modalOpener: document.activeElement as HTMLElement, // Save element that trigger the open modal action
            firstFocusableElement: undefined as unknown as HTMLElement,
            lastFocusableElement: undefined as unknown as HTMLElement,
            documentScrollTop: 0 as number,
        };
    },
    mounted: function() {
        this.documentScrollTop = (
            document.scrollingElement ||
            document.documentElement ||
            document.body.parentNode ||
            document.body
        ).scrollTop;

        // Get the scrollBar width
        var scrollBarWidth = window.innerWidth - document.documentElement.clientWidth;

        // Get all focusable elements of the modal
        var focusableElements = Array.from(this.$el.querySelectorAll(
            "a[href], area[href], input:not([disabled]), select:not([disabled]), textarea:not([disabled]), button:not([disabled]), [tabindex=\"0\"]"
        )) as HTMLElement[];

        var visibleFocusableElements = focusableElements.filter(element => this.isVisible(element));

        // Get the first focusable element
        this.firstFocusableElement = visibleFocusableElements[0];

        // Set focus on first focusable element of the modal
        if(this.firstFocusableElement !== undefined) {
            this.firstFocusableElement.focus();
        }

        // Save last focusable element of the modal
        this.lastFocusableElement = focusableElements.pop() as unknown as HTMLElement;

        // Add a Modal-Open class on html tag (disable scroll in css)
        document.documentElement.classList.add("js-fullscreen");

        // Add padding right to mainContainer to avoid content shifting to the right when scrollbar disapear
        // Keep in mind that fixed element (e.g top-navigation and property-page-header) should also adapt their position. This is handle specificaly in concerned component
        var mainContainer = document.getElementById("main-container");

        if (mainContainer !== null) {
            mainContainer.setAttribute("style", "padding-right:" + scrollBarWidth + "px;");
        }
    },
    destroyed: function() {
        // Set focus back on the element that trigger the modal opening
        this.modalOpener.focus();
        // Remove Modal-Open class on html tag
        document.documentElement.classList.remove("js-fullscreen");

        window.scroll(0, this.documentScrollTop);

        // Remove padding-right on mainContainer
        var mainContainer = document.getElementById("main-container");

        if (mainContainer !== null) {
            mainContainer.removeAttribute("style");
        }
    },
    methods: {
        close: function(response: boolean) {
            this.$emit("close", this.item, response);
        },
        handleTabPress: function(event: KeyboardEvent) {
            if (event.shiftKey === true) {
                //Tab backward

                // Specific case if first focusable element is a radio button
                // When you focus backward on a radio group, the browser focus on the last radio button of the group,
                // but leave the group on the next tab backward.
                // So the original condition (activElement === firstFocusableElement) is never met
                // Do the check on the grandparent (the fieldset) to achieve the same desired behavior
                if(this.firstFocusableElement.getAttribute("type") === "radio") {
                    const firstFocusableElementGrandParent = this.firstFocusableElement?.parentElement?.parentElement;
                    const activeElementGrandParent = document?.activeElement?.parentElement?.parentElement;

                    if(activeElementGrandParent === firstFocusableElementGrandParent) {
                        event.preventDefault();
                        this.lastFocusableElement.focus();
                    }

                } else {
                    if (document.activeElement === this.firstFocusableElement) {
                        event.preventDefault();
                        this.lastFocusableElement.focus();
                    }
                }
            } else {
                // Tab forward
                if (document.activeElement === this.lastFocusableElement) {
                    event.preventDefault();
                    this.firstFocusableElement.focus();
                }
            }
        }
    }
});
